<div
  *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.Lineage"
  appScaleDownText
  [scaleEnabled]="!(menu | isPrintMenu)"
  [style.color]="
    ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
      ? (section | textColorBasedOnSectionHeaderBackgroundColor)
      : (menu | productMenuBasicMethod: 'getSectionHeaderTextColor' : section)
  "
  class="section-header-general section-header-lineage">
  {{ menu | productMenuBasicMethod: 'getLineageColumnTitle' : colVm }}
</div>
